import React, { useRef } from 'react'
import {
  Layout,
  Menu,
  Form,
  ConfigProvider,
  message,
  Input,
  Modal,
  Button,
  Dropdown,
  Popover,
  Drawer,
} from 'antd'
import styles from './index.module.scss'
import zhCH from 'antd/lib/locale/zh_CN'
import photo from '../../assets/u3.png'
import logo from '../../assets/u27.png'
import {
  useLocation,
  Switch,
  Route,
  Link,
  useHistory,
  Router,
} from 'react-router-dom'
import { createFromIconfontCN } from '@ant-design/icons'
import Home from './Home'
import IntellectWrite from './IntellectWrite'
import { useDispatch, useSelector } from 'react-redux'
import {
  changePassword,
  getMenuOfPersonal,
  getMenus,
  getUserInfo,
  logout,
} from '../../store/actions/login'
import CompManage from './SysManage/CompManage'
import routes from '../../routers/index'
import Usermanage from './SysManage/UserManage'
import { useState } from 'react'
import routers, { MyIcon } from '../../routers/index'
import PrivateRoute from '../../components/PrivateRoute'
import OrgManage from './SysManage/OrgManage'
import MenuManage from './SysManage/MenuManage'
import FucManage from './SysManage/FucManage'
import RoleManage from './SysManage/RoleManage'
import ConfigManage from './SysManage/ConfigManage'
import Help from '../Help'
import ServiceAgreement from '../ServiceAgreement'
import PrivacyAgreement from '../PrivacyAgreement'
import ContactInformation from '../ContactInformation'
import License from './SysManage/License'
import { useEffect } from 'react'
import {
  getCallbackUrl,
  getCompany,
  getDeploy,
  getLogoUrl,
  getSuperGroup,
  getTitleName,
  removeCompany,
  removeOaOrg,
  removeSuperGroup,
  removeToken,
  removeUserStatus,
  setRedirectUrl,
  setSuperGroup,
  setToken,
} from '../../utils/cookie'
import DataDictionary from './SysManage/DataDictionary'
import request from '../../utils/request'
import ProductConfgTemp from './SysManage/ProductConfgTemp'
import JournalManage from './SysManage/JournalManage'
import UpdateLogManage from './SysManage/UpdateLogManage'
import MyButton from '../../components/MyButton'
import { getUpdateLogList } from '../../store/actions/updates'
import Nofunc from '../Nofunc'
import NoProject from '../NoProject'
import MyHeader from '../../components/MyHeader'
import api from '../../api'
import { judgingStatus } from '../../utils/judgingStatus'
import GuidePage from '../GuidePage'
import NoSubScribe from '../NoSubscribe'
import ServiceActivation from '../ServiceActivation'
import { getLocationOrigin } from '../../utils/util'
import { urlMap } from '../../utils/urlMap'
const { Header, Content, Sider } = Layout

export default function MyLayout() {
  const location = useLocation()
  let pathname = location.pathname
  const [isModal, setIsModal] = useState(false)
  const [collapsed, setCollapsed] = useState(false)
  const [ispopover, setIspopover] = useState(false)
  const [helpPopover, setHelpPopover] = useState(false)
  const [watch, setWatch] = useState(false)
  const { menus } = useSelector((state) => state.login)
  const { total, updatelogList } = useSelector((state) => state.updates)
  const dispatch = useDispatch()
  const history = useHistory()
  const changeForm = useRef({})

  const [form] = Form.useForm()

  window.urlMap = urlMap

  useEffect(() => {
    dispatch(getUserInfo())
  }, [dispatch])

  const userInfo = useSelector((state) => state.login.userInfo)
  const { user } = userInfo

  useEffect(() => {
    if (
      urlMap.noProject() ||
      urlMap.guidePage() ||
      urlMap.nosubScribe() ||
      JSON.stringify(userInfo) === '{}'
    ) {
      dispatch(
        getMenus({
          not_check: true,
        })
      )
      return
    }
    const status = judgingStatus(userInfo?.status)
    console.log('----------status--------->', status)
    if (status) {
      let path = '/saas/noProject'
      if (status === 1 && (userInfo?.is_admin || userInfo?.is_creator)) {
        path = '/saas/guidePage'
      } else if (status === 3) {
        path = '/saas/guidePage'
      }
      if (getDeploy() === 'BOX') {
        path = '/home/nosubScribe'
      }
      history.push(path)
      return
    }
    dispatch(
      getMenus({
        co_id: getCompany(),
      })
    )
  }, [userInfo])

  const confirm = () => {
    let saas = undefined
    let redirect = getLocationOrigin() + '/loginHtml'
    if (urlMap.noProject() || urlMap.guidePage()) {
      saas = true
      if (getCallbackUrl()) {
        redirect = getCallbackUrl()
      }
    }
    request
      .post('sys/logout/', {
        redirect: redirect,
        saas: getDeploy() === 'BOX' ? undefined : saas,
      })
      .then((res) => {
        if (res.data.data.status === 'redirect') {
          removeToken()
          removeUserStatus()
          removeSuperGroup()
          removeCompany()
          removeOaOrg()
          setRedirectUrl(window.location.href)
          if (res.data.data.logout_url) {
            window.location.href = res.data.data.logout_url
          } else {
            window.location.reload()
          }
        }
      })
    message.success('退出成功')
  }

  const showModal = (e) => {
    e.stopPropagation()
    setIsModal(true)
    setIspopover(false)
  }

  const changePass = () => {
    form
      .validateFields()
      .then(async (res) => {
        const values = form.getFieldsValue()
        const result = await dispatch(changePassword(values))
        if (result.data.code === 0) {
          setIsModal(false)
          message.success(result.data.msg)
          setTimeout(() => {
            dispatch(logout())
            history.replace('/home')
          }, 500)
        }
      })
      .catch((error) => {
        return
      })
  }

  function openIframe(url, title = '') {
    const iframe = document.createElement('iframe')
    iframe.src = url
    iframe.style.width = '100%'
    iframe.style.height = '50vh'
    iframe.style.border = 'none'
    iframe.title = title

    // 创建容器
    const container = document.createElement('div')
    container.style.position = 'fixed'
    container.style.top = '0'
    container.style.left = '0'
    container.style.width = '50%'
    container.style.height = '50%'
    container.style.backgroundColor = 'white'
    container.style.zIndex = '1000'

    // 添加关闭按钮
    const closeBtn = document.createElement('button')
    closeBtn.textContent = '× 关闭'
    closeBtn.style.position = 'absolute'
    closeBtn.style.right = '20px'
    closeBtn.style.top = '20px'
    closeBtn.style.zIndex = '1001'
    closeBtn.onclick = () => document.body.removeChild(container)

    container.appendChild(closeBtn)
    container.appendChild(iframe)
    document.body.appendChild(container)
  }

  const to = (item) => {
    if (item.menu_url && item.open_mode === 'CURRENT_PAGE') {
      history.push(item.menu_url)
      if (item.menu_url === pathname) {
        history.push(item.menu_url)
      }
    } else if (item.menu_url && item.open_mode === 'NEW_PAGE') {
      window.open(item.menu_url)
    } else if (item.menu_url && item.open_mode === 'IFRAME') {
      console.log(item)
      openIframe(item.menu_url, item.dic_item_name)
    }
  }
  const MyIcon = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/c/font_3250468_9m0idceqk1m.js',
  })

  useEffect(() => {
    dispatch(getMenuOfPersonal())
  }, [dispatch])

  const { personalMenus, licenseName } = useSelector((state) => state.login)
  const initMenu = (list, isChildren) => {
    list = list?.map((item) => {
      if (item.children && item.children.length > 0) {
        return (
          <Menu.SubMenu
            // icon={item.icon}
            icon={
              isChildren ? null : item.icon ? (
                <img
                  alt=""
                  style={{
                    width: 16,
                    height: 16,
                  }}
                  src={item.icon}
                />
              ) : (
                <MyIcon type="icon-zhinengzhuanxie18x18" />
              )
            }
            title={item.menu_name}
            key={item.menu_url || item.menu_code}
          >
            {initMenu(item.children, true)}
          </Menu.SubMenu>
        )
      }

      return (
        <Menu.Item
          key={item.menu_url || item.menu_code}
          icon={
            isChildren ? null : item.icon ? (
              <img
                alt=""
                style={{
                  width: 16,
                  height: 16,
                }}
                src={item.icon}
              />
            ) : (
              <MyIcon type="icon-zhinengzhuanxie18x18" />
            )
          }
        >
          <a onClick={() => to(item)} title={item.menu_name}>
            {item.menu_name}
          </a>
        </Menu.Item>
      )
    })
    return list
  }

  //切换企业成功回调
  const switchEnterpriseSuccessFunc = (data) => {
    setToken(data?.data.token || '')
    sessionStorage.setItem('isEnterpriseSwitching', true)
    if (urlMap.noProject() || urlMap.nofunc() || urlMap.guidePage()) {
      window.location.href = getLocationOrigin() + '/home'
      // history.push('/home')
      return
    }
    window.location.reload()
  }

  const authCallBack = (type) => {
    console.log('------', type)
  }

  const menuClickCallBack = (item) => {
    if (item.menu_name === '帮助中心') {
      window.open(item.menu_url + '系统管理', item?.menu_name)
      return true
    }
  }

  return (
    <ConfigProvider locale={zhCH}>
      <div className={styles.root}>
        <MyHeader
          showUserMenusMinLength={0}
          userInfo={userInfo}
          logoUrl={localStorage.getItem('logo_url')}
          personalMenus={personalMenus}
          userMenus={menus}
          logoutBack={confirm}
          getUnreadNoticesFunc={api.getUnreadNotices}
          getNoticesFunc={api.getNotices}
          setReadNoticesFunc={api.setReadNotices}
          deleteNoticesFunc={api.deleteNotices}
          getUpdateLogList={api.getUpdateLogList}
          editCompName={api.editCompName}
          getEnterpriseFunc={api.getEnterprise}
          validationFunc={(res) => res.data?.code === 0 || res.code === 0}
          switchEnterpriseFunc={api.switchEnterpriseById}
          switchEnterpriseCallBack={switchEnterpriseSuccessFunc}
          licenseName={licenseName}
          projectCode="SYS_MANAGE"
          authCallBack={authCallBack}
          menuClickCallBack={menuClickCallBack}
        ></MyHeader>
        <Layout className="my-layout">
          {!urlMap.nofunc() &&
            !urlMap.noProject() &&
            !urlMap.guidePage() &&
            !urlMap.nosubScribe() && (
              <Sider
                trigger={null}
                width={216}
                style={{
                  background:
                    'linear-gradient(223deg, #006bb3 0%, #15d2d6 100%)',
                }}
                className="site-layout-background"
                collapsible
                collapsed={collapsed}
              >
                <div className="logo">
                  {!collapsed && (
                    // <img
                    //   src={getLogoUrl() !== 'undefined' ? getLogoUrl() : logo}
                    //   alt=""
                    // />
                    <div className="logoBox">
                      <img
                        src={
                          menus?.find((_) => _.menu_code === 'SYS_MANAGE')?.icon
                        }
                        alt=""
                      />
                      <span>
                        {
                          menus?.find((_) => _.menu_code === 'SYS_MANAGE')
                            ?.menu_name
                        }
                      </span>
                    </div>
                  )}
                  <span>
                    {collapsed ? (
                      <MyIcon
                        className="anticon-menu-fold"
                        type="icon-toggle-right1"
                        onClick={() => setCollapsed(!collapsed)}
                      ></MyIcon>
                    ) : (
                      <MyIcon
                        className="anticon-menu-unfold "
                        type="icon-toggle-left2"
                        onClick={() => setCollapsed(!collapsed)}
                      ></MyIcon>
                    )}
                  </span>
                </div>
                <Menu
                  mode="inline"
                  style={{ height: '100%', borderRight: 0 }}
                  selectedKeys={[pathname]}
                  defaultOpenKeys={['/home/sysmanage']}
                >
                  {/* 遍历路由 */}
                  {initMenu(
                    menus
                      .filter((item) => item.menu_code === 'SYS_MANAGE')
                      .reduce((acc, obj) => {
                        if (obj.menu_code === 'SYS_MANAGE') {
                          acc.push(...obj.children)
                        } else {
                          acc.push(obj)
                        }
                        return acc
                      }, [])
                  )}
                </Menu>
              </Sider>
            )}

          <Layout id="right_content" style={{ position: 'relative' }}>
            <Content className="site-layout-background">
              <Switch key={location.key}>
                <PrivateRoute
                  exact
                  path="/home"
                  component={Home}
                ></PrivateRoute>
                <PrivateRoute
                  path="/home/intellectwrite"
                  component={IntellectWrite}
                ></PrivateRoute>
                <PrivateRoute
                  path="/home/sysmanage/license"
                  component={License}
                ></PrivateRoute>
                <PrivateRoute
                  path="/home/sysmanage/compmanage"
                  component={CompManage}
                ></PrivateRoute>
                <PrivateRoute
                  path="/home/sysmanage/usermanage"
                  component={Usermanage}
                ></PrivateRoute>
                <PrivateRoute
                  path="/home/sysmanage/orgmanage"
                  component={OrgManage}
                ></PrivateRoute>
                <PrivateRoute
                  path="/home/sysmanage/menumanage"
                  component={MenuManage}
                ></PrivateRoute>
                <PrivateRoute
                  path="/home/sysmanage/fucmanage"
                  component={FucManage}
                ></PrivateRoute>
                <PrivateRoute
                  path="/home/sysmanage/rolemanage"
                  component={RoleManage}
                ></PrivateRoute>
                <PrivateRoute
                  path="/home/sysmanage/datadictionary"
                  component={DataDictionary}
                ></PrivateRoute>
                <PrivateRoute
                  path="/home/sysmanage/configmanage"
                  component={ConfigManage}
                ></PrivateRoute>
                <PrivateRoute
                  path="/home/sysmanage/productconfgtemp"
                  component={ProductConfgTemp}
                ></PrivateRoute>
                <PrivateRoute
                  path="/home/sysmanage/journalmanage"
                  component={JournalManage}
                ></PrivateRoute>
                <PrivateRoute
                  path="/home/sysmanage/updatelogmanage"
                  component={UpdateLogManage}
                ></PrivateRoute>
                <Route path="/help" component={Help}></Route>
                <PrivateRoute
                  path="/home/nofunc"
                  component={Nofunc}
                ></PrivateRoute>
                <PrivateRoute
                  path="/home/nosubScribe"
                  component={NoSubScribe}
                ></PrivateRoute>
                <PrivateRoute
                  path="/saas/noProject"
                  component={NoProject}
                ></PrivateRoute>
                <PrivateRoute
                  path="/saas/guidePage"
                  component={GuidePage}
                ></PrivateRoute>
                <Route
                  path="/legal-agreement/tos.html"
                  component={ServiceAgreement}
                ></Route>
                <Route
                  path="/legal-agreement/privacy.html"
                  component={PrivacyAgreement}
                ></Route>
                <Route
                  path="/legal-agreement/about.html"
                  component={ContactInformation}
                ></Route>
                <Route path="/home/sysmanage/serviceActivation" component={ServiceActivation}></Route>

              </Switch>
            </Content>
          </Layout>
        </Layout>
      </div>
    </ConfigProvider>
  )
}
